import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { Category } from "../../../@types/Category";
import axiosInstance from "../../../utils/axiosConfig";

export const createFileType = createAsyncThunk(
  "fileTypes/createFileType",
  async (fileType: Category, { rejectWithValue }) => {
    try {
      const {
        name,
        module,
        isSignable,
        datesRequire,
        expirationDays,
        htmlDescription,
        enabled,
        requireCode,
        sendMessageWhatsApp,
        sendMessageSMS,
      } = fileType;

      const { data } = await axiosInstance.post(`${api.baseURL}category`, {
        name,
        module,
        isSignable,
        datesRequire,
        expirationDays,
        htmlDescription,
        enabled,
        requireCode,
        sendMessageWhatsApp,
        sendMessageSMS,
      });

      return data as Category;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
